import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import HotelOverview from 'static-components/src/vue/offer/hotel-overview-card.vue';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
import { Products } from 'helper';
import { HotelBaseDataClient, store, ProductType } from 'ltur-state-engine';
import InputValueSetup from "Helper/InputValueSetup";
var initializeHotelOverview = function () {
    var initialized = false;
    store.subscribe(function () {
        if (!initialized && Products.isStateReadyForHotelBaseDataQuery()) {
            initialized = true;
            setTimeout(function () {
                var productType = store.getState().websiteState.app.url.context.productType;
                if (ProductType.HOTEL == productType) {
                    var inputValueSetup = new InputValueSetup();
                    inputValueSetup.initializeHotel();
                }
                HotelBaseDataClient.fetchAndDispatchHotelBaseDataAsync();
                if (ProductType.HOTEL == productType) {
                    Products.getOffersAsync();
                }
                else {
                    Products.getPackageFlightAlternativesAsync();
                }
                Products.getVariantsAsync();
                Products.getQueryOptionsAsync();
            });
        }
    });
    Vue.use(VueCustomElement);
    // @ts-ignore
    Vue.customElement('c-hotel-overview', (new HotelOverview().$options), vueCustomElementOptions);
};
export default initializeHotelOverview;
